import React, { useState, useEffect } from 'react';
import { get, post } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon } from '../icons';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../components/Breadcrumb';
import PaginationInPage from '../Pagination';
import moment from 'moment';
import DeleteModal from '../../components/common/DeleteModal';
import { useForm } from 'react-hook-form';

const NamkeenOrderBlocks = () => {
  const formFields = {
    date: '',
    tripNumber: '',
    reason: '',
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [deleteModel, setDeleteModel] = useState(false);
  const [idToDelete, setIdToDelete] = useState('');
  const [blockList, setBlockList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const { register, handleSubmit, reset, watch } = useForm({
    defaultValues: formFields,
  });

  const getBlocks = () => {
    let url = `/cake/namkeen-order-blocks?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
    get(url).then((response) => {
      setBlockList(response.data.rows);
      setTotalRecords(response.data.count ?? 0);
    });
  };

  const handleShow = () => {
    setShowConfirmModel(true);
    reset(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleDelete = (e, id) => {
    e.preventDefault();
    setIdToDelete(id);
    setDeleteModel(true);
  };

  const onSubmit = async (data) => {
    if (!data.date || !data.tripNumber) {
      toast.error('Date and Trip Number are required.');
      return;
    }

    if (moment(data.date).isBefore(moment(), 'day')) {
      toast.error('Cannot block dates in the past.');
      return;
    }

    await post(data, '/cake/namkeen-order-blocks', false)
      .then(() => {
        toast.success('Block added successfully');
        setShowConfirmModel(false);
        getBlocks();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message);
      });
  };

  useEffect(() => {
    getBlocks();
  }, [currentPage]);

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '/cake/home', title: 'Home' },
          { link: '#', title: 'Master' },
          { link: '#', title: 'Namkeen Order Blocks' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Namkeen Order Blocks | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add Block
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Trip Number</th>
                    <th>Reason</th>
                    <th>Created By</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {blockList?.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{moment(item?.date).format('DD/MM/YYYY')}</td>
                        <td>{item?.tripNumber}</td>
                        <td>{item?.reason || '-'}</td>
                        <td>{item?.creator?.name || '-'}</td>
                        <td>{moment(item?.createdAt).format('DD/MM/YYYY hh:mm A')}</td>
                        <td className="actions">
                          <span className="delete-icon" onClick={(e) => handleDelete(e, item?.id)}>
                            <DeleteIcon style={{ color: 'red' }} />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal size="md" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Block</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col xs={6}>
                <FloatingLabel label="Date" className="mb-3">
                  <Form.Control
                    className="input"
                    {...register('date', { required: true })}
                    type="date"
                    placeholder="Date"
                    required
                    autoComplete="false"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel label="Trip Number" className="mb-3">
                  <Form.Control
                    className="input"
                    {...register('tripNumber', { required: true })}
                    type="number"
                    placeholder="Trip Number"
                    required
                    autoComplete="false"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={12}>
                <FloatingLabel label="Reason (Optional)" className="mb-3">
                  <Form.Control
                    className="input"
                    {...register('reason')}
                    type="text"
                    placeholder="Reason for blocking"
                    autoComplete="false"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <div className="container text-center">
              <Button type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                Add
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <DeleteModal
        title="Delete Block"
        description="Are you sure you want to delete this block? This action cannot be undone."
        open={deleteModel}
        url={`/cake/namkeen-order-blocks/${idToDelete}`}
        onClose={() => {
          setIdToDelete('');
          setDeleteModel(false);
        }}
        callback={getBlocks}
      />
    </>
  );
};

export default NamkeenOrderBlocks;
